import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import LoadingWithLable from "./../../../../../../ReusableComponents/Loading/LoadingWithLable";

export default function CostSheetView({
  defaultRows = [],
  setData,
  setRowEdited,
  optionArrays = {},
}) {
  const [allRows, setAllRows] = useState([]);

  useEffect(() => {
    setAllRows(defaultRows);
  }, [defaultRows]);

  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-orange-400",
      bgSecondary: "bg-orange-200",
    },
    {
      rate_category_id: 2,
      title: "GOVERNMENT FEES (PER MONTH)",
      bgPrimary: "bg-cyan-700",
      bgSecondary: "bg-cyan-200",
    },
    {
      rate_category_id: 3,
      title: "SOUNDLINE FEES (ACTUALS & PER MONTH)",
      bgPrimary: "bg-green-800",
      bgSecondary: "bg-green-200",
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };

  const handleUpdateColumn = (
    rowId,
    rate_category_id,
    columnId,
    updatedKey,
    updatedValue
  ) => {
    setRowEdited(true);
    const updatedRows = allRows.map((row) => {
      if (updatedKey == "cost") {
        if (row.id == rowId) {
          const updatedSections = row.sections.map((section) => {
            if (section.rate_category_id == rate_category_id) {
              const updatedColumns = section.columns.map((column) => {
                if (column.id == columnId) {
                  return {
                    ...column,
                    [updatedKey]: updatedValue,
                  };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }

            return section;
          });
          return { ...row, sections: updatedSections };
        }
        return row;
      }
    });

    setAllRows(updatedRows);
  };

  //final data

  useEffect(() => {
    const costSheet = [];
    const costSheetHeadingType = [];
    for (let i = 0; i < allRows.length; i++) {
      const costSheetHeadingContent = [];
      for (let section of allRows[i].sections) {
        for (let column of section.columns) {
          costSheetHeadingContent.push({
            heading_name:
              column?.rate_category_item_name ||
              column?.rate_category_item?.name,
            cost: String(column?.cost),
          });
          if (i == 0) {
            costSheetHeadingType.push({
              heading_name:
                column?.rate_category_item_name ||
                column?.rate_category_item?.name,
            });
          }
        }
      }

      costSheet.push({
        ...{
          job_position_id: allRows[i].job_position_id,
          visa_profession_id: allRows[i].visa_profession_id,
          profession_level_id: allRows[i].profession_level_id,
          gender: allRows[i].gender,
          nationality_id: allRows[i].nationality_id,
          quantity: allRows[i].quantity,
        },
        cost_sheet_heading: costSheetHeadingContent,
      });
    }

    setData((prev) => ({
      ...prev,
      cost_sheet: costSheet,
      cost_sheet_heading: costSheetHeadingType,
    }));
  }, [allRows]);

  return (
    <>
      {!defaultRows?.length <= 0 ? (
        <>
          <div className="flex flex-col w-full  gap-1 my-5 overflow-x-scroll">
            <div className="pb-5">
              {allRows.map((row, index) => (
                <div key={row.id} className="flex gap-1 mt-1">
                  {row.sections.map((section, sectionIndex) => (
                    <div
                      className="flex flex-col relative"
                      key={section.rate_category_id}
                    >
                      {index == 0 && (
                        <>
                          <div className={`flex w-full gap-1 `}>
                            {section.rate_category_id == 1 && (
                              <>
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  SL. NO.
                                </h3>
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  ACTUAL PROFESSION
                                </h3>
                                <h3
                                  className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  VISA PROFESSION
                                </h3>
                                <h3
                                  className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  PROFESSION LEVEL
                                </h3>
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  GENDER
                                </h3>
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  NATIONALITY
                                </h3>
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                >
                                  QUANTITY
                                </h3>
                              </>
                            )}
                            {section.columns.map((column) => (
                              <div
                                key={column.id}
                                className={`${tableHeading[sectionIndex].bgSecondary}  ${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative`}
                              >
                                <h3 className="text-center text-sm">
                                  {column.title}
                                </h3>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                      <div className="flex w-full gap-1 relative">
                        {section.rate_category_id == 1 && (
                          <>
                            <p
                              className={` bg-slate-200 flex items-center justify-center  ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {index + 1}
                            </p>

                            {/* ACTUAL PROFESSION / JOB POSITION  */}
                            <input
                              type="text"
                              className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              defaultValue={
                                optionArrays?.job_possition?.find(
                                  (data) => data?.id == row?.job_position_id
                                )?.name
                              }
                              disabled
                            />

                            {/* VISA PROFESSION */}
                            <input
                              type="text"
                              className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              defaultValue={
                                optionArrays?.visa_profession?.find(
                                  (data) => data?.id == row?.visa_profession_id
                                )?.name
                              }
                              disabled
                            />

                            {/* PROFESSION LEVEL */}
                            <input
                              type="text"
                              className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              defaultValue={
                                optionArrays?.profession_level?.find(
                                  (data) => data?.id == row?.profession_level_id
                                )?.name
                              }
                              disabled
                            />

                            {/* GENDER */}
                            <input
                              type="text"
                              className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              defaultValue={row?.gender}
                              disabled
                            />

                            {/* NATIONALITY */}
                            <input
                              type="text"
                              className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              defaultValue={
                                optionArrays?.nationality?.find(
                                  (data) => data?.id == row?.nationality_id
                                )?.name
                              }
                              disabled
                            />

                            {/* QUANTITY */}
                            <input
                              type="text"
                              className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              required
                              placeholder="ENTER QUANTITY"
                              defaultValue={row?.quantity}
                              disabled
                            />
                          </>
                        )}
                        {section.columns.map((column) => (
                          <React.Fragment key={`${row.id}-${column.id}`}>
                            {column?.inputType == "text" ? (
                              <input
                                type="text"
                                className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                placeholder={
                                  column?.placeholder || "Enter value"
                                }
                                value={column.cost}
                                required
                                onChange={(e) =>
                                  handleUpdateColumn(
                                    row.id,
                                    column.rate_category_id,
                                    column.id,
                                    "cost",
                                    e.target.value,
                                    column.rate_category_item_name
                                  )
                                }
                                disabled={column?.disabled}
                              />
                            ) : (
                              <input
                                type="number"
                                min={0}
                                step={"0.0001"}
                                className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                placeholder="Enter Cost"
                                value={column.cost}
                                required
                                onChange={(e) =>
                                  handleUpdateColumn(
                                    row.id,
                                    column.rate_category_id,
                                    column.id,
                                    "cost",
                                    parseFloat(e.target.value),
                                    column.rate_category_item_name
                                  )
                                }
                                disabled={column?.disabled}
                              />
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <LoadingWithLable />
      )}
    </>
  );
}
